import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PartnerInscriptionSuccessGuard implements CanActivate {
  private hasValidAccess = false;
  private router = inject(Router);


  canActivate(): boolean {
    if (this.hasValidAccess) {
      this.hasValidAccess = false;
      return true;
    }

    void this.router.navigate(['/cadastro-parceiros/inscricao/step-3']);
    return false;
  }

  grantAccess(): void {
    this.hasValidAccess = true;
  }
}

